import { vm } from '@/main';
import Mime from 'mime';
import store from '@/store';
import moment from 'moment-timezone';
const tz = 'Europe/Tallinn';

export function fixDate(date) {
    return moment(date).tz(tz).format('L');
}

export function fixDateTime(date) {
    return moment(date).tz(tz).format('L LT');
}

export function download(data, file) {
    const fileURL = window.URL.createObjectURL(new Blob([data], { type: file.mime_type }));
    const a = document.createElement('a');
    a.href = fileURL;
    a.setAttribute('download', file.filename);
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
}

export function cleanQueryObj(obj) {
    for (let propName in obj) {
        if (obj[propName] === null || obj[propName] === undefined || obj[propName] === '') {
            delete obj[propName];
        }
        if (obj.trashed === false) {
            delete obj.trashed;
        }
    }

    return obj;
}

export function formatBytes(a, b) {
    if (0 == a) return '0 Bytes';
    const c = 1024,
        d = b || 2,
        e = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
        f = Math.floor(Math.log(a) / Math.log(c));
    return parseFloat((a / Math.pow(c, f)).toFixed(d)) + ' ' + e[f];
}

export function stringToSlug(str) {
    str = str.replace(/^\s+|\s+$/g, '');
    str = str.toLowerCase();

    let from = 'àáãäâèéëêìíïîõòóöôùúüûñç·/_,:;';
    let to = 'aaaaaeeeeiiiiooooouuuunc------';

    for (let i = 0, l = from.length; i < l; i++) {
        str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
    }
    str = str
        .replace(/[^a-z0-9 -]/g, '')
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-');

    return str;
}

export function validityPeriod(pricelist) {
    return `${addZero(pricelist.start[0])}.${addZero(pricelist.start[1])} - ${addZero(pricelist.end[0])}.${addZero(
        pricelist.end[1]
    )}`;
}

function addZero(num) {
    if (String(num).length === 1) {
        return `0${num}`;
    }
    return num;
}
